import React from 'react';
import { Auth } from 'aws-amplify';
import '../../assets/Nav.css';
import { MdLogout } from 'react-icons/md';
import { useSearchParams } from 'react-router-dom';

// Propsの型を定義
interface LogoutProps {
  onLogout: () => void;
  checkCurrentUser: () => Promise<void>;
}

const Logout: React.FC<LogoutProps> = ({ onLogout, checkCurrentUser }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const handleLogout = async () => {
    try {
      sessionStorage.clear();
      await Auth.signOut();
      setSearchParams({});
      onLogout();
      await checkCurrentUser();
      window.location.href = '/';
    } catch (error) {
      console.error('Error signing out: ', error);
    }
  };

  return (
    <li className="nav-list nav-link">
      <a onClick={handleLogout}>
        <MdLogout className="mt-1 w-5 h-5" />
      </a>
    </li>
  );
};

export default Logout;
